module.exports = __webpack_public_path__ + "static/media/droom.72b7c0f1.png";